import * as React from 'react';
import axios from 'axios';
import {
  Cart, Color,
  Emplacement,
  Marquage,
  nbPanachage,
  Order,
  Picto,
  Surface,
  Thumbnail,
  validationVisuel,
  conformiteVisuel,
  Model3dViewData
} from './iMonCompte';
import {RenderArticleConcerne} from './RenderArticleConcerne';
import {getUserId, sessionExpire} from './MonCompteAction';
import RenderContentFilesGlobalLine from './RenderContentFilesGlobalLine';
import {getHostApi, getRequestConfig} from '../../utils';
import {getShopInfosInStorage} from "../cart/ShopInfos";
import Model3dView from './upload/components/Model3dView';
import RequestQueue from './upload/RequestQueue';
import { FormGenerateTexture } from './upload/components/iUpload';

interface RenderContentFilesState {
  colors?: Color[];
  emplacements?: Emplacement[];
  surfaces?: Surface[];
  pictogrammes?: Picto[];
  preview?: Thumbnail;
  authorizedFiles?: any[];
  idCaddies?: any[];
  canValidate?: boolean;
  isReupload?: boolean;
  glbVersion?: number | null;
}

interface RenderContentFilesProps {
  orderId: string;
  order: Order;
  nbPanachages: nbPanachage[];
  activatePanachage: boolean;
  activatePanachageQuadriluxe: boolean;
  activatePanachageTopQuadri: boolean;
  activatePanachageSublimation: boolean;
  activatePanachageSericoat: boolean;
  activatePanachageBroderie: boolean;
  activateCheckImageUsage: boolean;
  selectPanachage: boolean;
  marquages: Marquage[];
  activateBatAuto: boolean;
  isBatAutoBroderie: boolean;
  contourCustom: boolean;
  isInternalUser: boolean;
  isInternalUserAdmin: boolean;
  customerView: boolean;

  canGallerie: boolean;
  canCustomDimensionsBatAuto: boolean;
  canUploadFichierDT: boolean;
  canUpdateFichierDestructure: boolean;
  customerChoixBroderie: boolean;
  canUpdateCmjn: boolean;
  canUpdateOutlineProcessing: boolean;
  canDownloadEmbroidery: boolean;
  canCheckImageUsage: boolean;
  hasClientFiles: boolean;
  enabledPostProcessing?: boolean;

  onOrderUpdated?(): void;
  onCanValidate?(canValidate: boolean): void;
  handleChangeRowValidationVisuelChecked?(array: validationVisuel) : void;
  handleChangeNonConformeChecked?(array: conformiteVisuel) : void;
  onChangeSurface?(currentKey: string, caddieIdentifier: string, newSurfaceId: number, newEmplacementId: number): void;
}

interface Params {
  pictogramme: Picto;
  surface: Surface;
  emplacement: Emplacement;
  color: Color;
  marquage: Marquage;
  idCaddies?: string;
  identifier?: string;
  nbArticles?: number;
  paniers?: Cart[];
}

export class RenderContentFiles extends React.Component<RenderContentFilesProps, RenderContentFilesState> {
  constructor(props: RenderContentFilesProps) {
    super(props);
    this.state = {
      authorizedFiles: [],
      colors: [],
      emplacements: [],
      surfaces: [],
      pictogrammes: [],
      idCaddies: [1]
    };
  }

  componentDidMount(): void {
    this._getData();
  }

  componentDidUpdate(nextProps: Readonly<RenderContentFilesProps>, nextContext: any): void {
    if( JSON.stringify(this.props.order) != JSON.stringify(nextProps.order)) {
      this._getData();
    } else  if (JSON.stringify(this.props) != JSON.stringify(nextProps)) {
      this._getColors(nextProps.order.idCommande);
    }

  }

  _sendCanValidate = (canValidate: boolean) => {
    if (this.props.onCanValidate) {
      this.props.onCanValidate(canValidate);
    }
  }

  _getData() {
    this._getColors();
    this._getEmplacements();
    this._getSurfaces();
    this._getPictos();
    this._getAuthorizedFiles();
    const shopInfos = getShopInfosInStorage();
    if (shopInfos.Ref == 'DT') {
      this. _getIdCaddies();
    }
  }

  _getIdCaddies() {
    const result: any = [];
    for (const idCaddie of this.props.order.panier) {
      result.push(idCaddie.idCaddies);
    }
    this.setState({idCaddies: result});
  }

  _onCanValidate = (canValidate: boolean) => {
    this._sendCanValidate(canValidate);
  }

  _getAuthorizedFiles = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/galleries/authorized-file-extensions`,
      getRequestConfig()).then((response) => {
      if(this.props.activateBatAuto) {
        this.setState({authorizedFiles: response.data.authorized_files_bat_auto});
      } else {
        this.setState({authorizedFiles: response.data.authorized_files});
      }
    }).catch((error) => {
      console.log(error);
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _assignColorsState = () => {
    const cmjn: any = [];
    const result: Color[] = [];
    if(this.state.colors) {
      for (const color of this.state.colors) {
        if (cmjn.indexOf(color.cmjn.cyan + '-' + color.cmjn.magenta + '-' + color.cmjn.jaune + '-' +
          color.cmjn.noir) === -1) {
          cmjn.push(color.cmjn.cyan + '-' + color.cmjn.magenta + '-' + color.cmjn.jaune + '-' + color.cmjn.noir);
          result.push(color);
        }
      }
      this.setState({colors: result});
    }
  }

  _getColors(commandeId: any = null) {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${(commandeId || this.props.order.idCommande)}/colors`,
      getRequestConfig()).then((response) => {
      if (response.data.colors) {
        this.setState({colors: response.data.colors}, () => {
          this._assignColorsState();
        });
      }
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getEmplacements() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${(this.props.order.idCommande)}/emplacements-marquage`,
      getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({emplacements: response.data});
      }
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        sessionExpire();
      }
    });
  }
  _getSurfaces() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${(this.props.order.idCommande)}/surfaces-marquage`,
      getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({surfaces: response.data});
      }
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getPictos() {
    axios.get(`${getHostApi()}/shops/pictogrammes`, getRequestConfig())
      .then((response) => {
        if (response.data) {
          this.setState({pictogrammes: response.data});
        }
      }).catch((error) => {
      if (error.response && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  defineEmplacementToPrint = (emplacementName: string) => {
    if(this.state.emplacements) {
      for (const emplacement of this.state.emplacements) {
        if (emplacement.nom === emplacementName) {
          return emplacement;
        }
      }
    }
  }

  definePictogrammeToPrint = (pictoName: string) => {
    if(this.state.pictogrammes) {
      for (const pictogramme of this.state.pictogrammes) {
        if (pictogramme.nom === pictoName) {
          return pictogramme;
        }
      }
    }
  }

  defineColorToPrint = (colorToTest: Color) => {
    if(this.state.colors) {
      for (const color of this.state.colors) {
        if (color.Couleur === colorToTest.Couleur) {
          return color;
        } else if (color.cmjn.cyan === colorToTest.cmjn.cyan && color.cmjn.magenta === colorToTest.cmjn.magenta &&
          color.cmjn.jaune === colorToTest.cmjn.jaune && color.cmjn.noir === colorToTest.cmjn.noir) {
          const colorBis = {...color};
          colorBis.code1 = colorToTest.code1;
          return colorBis;
        }
      }
    }
  }

  definePaniersAndPictos = (paniers: Cart[]) => {
    const pictoInCart: any = [];

    for (const index in paniers) {
      const panier = paniers[index];

      if (!Array.isArray(panier.article.produit.picto)) {
        pictoInCart[panier.article.produit.picto.id] = panier.article.produit.picto;
      } else {
        // Si le produit n'a pas de picto, on choisi le picto indéfini
        const undefinedPicto: any = {
          id: '32',
          nom: 'indefini',
        };
        paniers[index].article.produit.picto = undefinedPicto;
        pictoInCart['32'] = undefinedPicto;
      }
    }
    return [paniers, pictoInCart];
  }

  _listOfMarking = () => {
    const couleursImpression: any = [];
    for (const panier of this.props.order.panier) {
      if (couleursImpression.indexOf(panier.couleurs_marquage) === -1) {
        couleursImpression.push(panier.couleurs_marquage);
      }
    }
    return couleursImpression;
  }

  handleChangeRowValidationVisuelChecked = (array: validationVisuel) => {
    if(this.props.handleChangeRowValidationVisuelChecked){
      this.props.handleChangeRowValidationVisuelChecked(array);
    }
  }

  handleChangeNonConformeChecked = (array: conformiteVisuel) => {
      this.props?.handleChangeNonConformeChecked?.(array);
  }
  
  onWithBeforeStatusIdUpdated = (withBeforeUploadStatusId: number, creationId: string, isReupload: boolean) => {
    this.setState({
      [creationId]: withBeforeUploadStatusId,
      isReupload
    });
  }

  updateTextureGlb = (creationId: string, glbLoading: boolean, glbVersion: number | null = Math.random()) => {
    this.setState({
        glbVersion: glbVersion,
        [creationId + "-glbLoading"]: glbLoading
    })
  }

  onQueueGlBTexture = (creationId: string, data: FormGenerateTexture) => {
    this.setState({
      [creationId + "-dataFormGlb"]: data
    })
  }

  render() {
    const renderLigneGlobale = (params: any, nbArticles: number, paniers: Cart[]) => {
      if (params && params.color && params.color.Couleur && params.emplacement && params.emplacement.id && params.pictogramme && paniers[0] && params.pictogramme) {
        const identifier: string = params.idCaddies + '-' + params.identifier;
        const keyVisuel: string = paniers[0].idCaddies + '-' + params.surface.id + '-' + params.emplacement.id;
        const key = params.pictogramme.id + '-' + params.color.Couleur + '-' + params.emplacement.id + '-' +
          params.surface.id + params.marquage.id + '-' + params.idCaddies + '-' + params.couleurs_marquage;
        return <div key={key}><RenderContentFilesGlobalLine identifier={identifier} emplacement={params.emplacement}
                                                            canGallerie={this.props.canGallerie}
                                                            canCustomDimensionsBatAuto={this.props.canCustomDimensionsBatAuto}
                                                            authorizedFiles={this.state.authorizedFiles}
                                                            marquage={params.marquage}
                                                            nbArticles={nbArticles} surface={params.surface}
                                                            paniers={paniers}
                                                            onChangeSurface={this.onChangeSurface}
                                                            order={this.props.order} key={key}
                                                            onCanValidate={this._onCanValidate}
                                                            pictogramme={params.pictogramme} color={params.color}
                                                            hasClientFiles={this.props.hasClientFiles}
                                                            activateBatAuto={this.props.activateBatAuto}
                                                            isBatAutoBroderie={this.props.isBatAutoBroderie}
                                                            contourCustom={this.props.contourCustom}
                                                            customerChoixBroderie={this.props.customerChoixBroderie}
                                                            isInternalUser={this.props.isInternalUser}
                                                            isInternalUserAdmin={this.props.isInternalUserAdmin}
                                                            canUpdateFichierDestructure={this.props.canUpdateFichierDestructure}
                                                            canUploadFichierDT={this.props.canUploadFichierDT}
                                                            canUpdateCmjn={this.props.canUpdateCmjn}
                                                            canDownloadEmbroidery={this.props.canDownloadEmbroidery}
                                                            canCheckImageUsage={this.props.canCheckImageUsage}
                                                            canUpdateOutlineProcessing={this.props.canUpdateOutlineProcessing}
                                                            activateCheckImageUsage={this.props.activateCheckImageUsage}
                                                            customerView={this.props.customerView}
                                                            handleChangeRowValidationVisuelChecked={this.handleChangeRowValidationVisuelChecked}
                                                            handleChangeNonConformeChecked={this.handleChangeNonConformeChecked}
                                                            onWithBeforeStatusIdUpdated={this.onWithBeforeStatusIdUpdated}
                                                            isReupload={this.state.isReupload}
                                                            updateTextureGlb={this.updateTextureGlb}
                                                            onQueueGlBTexture={this.onQueueGlBTexture}
                                                            keyVisuel={keyVisuel}/>
        </div>;
      }
    };

    const renderArticlesConcernes = (articlesConcernes: any[], identifier: string) => {
      if(articlesConcernes && articlesConcernes.length > 0 ) {
        const id = `articlesConcernes-${identifier}`;
        return (
          <div key={id} id={id} className="detailsArticles">
            {articlesConcernes}
            <div className="bg-black pt1 pb1 white text-center display-none">Fermer</div>
          </div>
        );
      }
    };

    const renderArticleConcerne = (params: any, i: number) => {
      let color;
      let surfaceToPrint;
      let emplacementToPrint;
      let nbArticlesConcernes = 0;
      const articlesConcernes: any = [];
      const paniersConcernes: any = [];
      const paniersPanaches: any = [];
      const paniersModel3d: Cart[] = [];
      let iNew = i;

      for (const panier of params.paniers) {
        const passByIdCaddies = getShopInfosInStorage().Ref === 'DT' ? panier.idCaddies === params.idCaddies : true;
        let sameColor = panier.article.couleur.cmjn &&
          panier.article.couleur.cmjn.cyan === params.color.cmjn.cyan &&
          panier.article.couleur.cmjn.magenta === params.color.cmjn.magenta &&
          panier.article.couleur.cmjn.jaune === params.color.cmjn.jaune &&
          panier.article.couleur.cmjn.noir === params.color.cmjn.noir;
        if(!sameColor && panier.article.couleur.cyan && params.color.cmjn.cyan ) {
          sameColor =  parseInt(panier.article.couleur.cyan) === params.color.cmjn.cyan &&  parseInt(panier.article.couleur.magenta) === params.color.cmjn.magenta &&  parseInt(panier.article.couleur.jaune) === params.color.cmjn.jaune &&  parseInt(panier.article.couleur.noir) === params.color.cmjn.noir;
        }
        const marquage = panier.marquages && panier.marquage === params.marquage.nom;
        if (marquage &&
          panier.article.produit.picto.nom === params.pictogramme.nom && sameColor && passByIdCaddies
        ) {
          for (const marquage of panier.marquages) {
            const keyCreationId = panier.creation_id === null ? 'null' : panier.creation_id;
            if (params.emplacement.nom === marquage.emplacement && params.surface.nom === marquage.surface &&
              panier.couleurs_marquage === params.printColor && keyCreationId === params.creationId) {
              color = panier.article.couleur;
              surfaceToPrint = params.surface;
              emplacementToPrint = params.emplacement;

              /** TODO : A décommenter lors de la mise en prod du panachage */
              if (panier.panachage == '0' && !panier.isModel3d) {
                iNew++;
                nbArticlesConcernes += Number(panier.Quantite);
                articlesConcernes.push(
                  <div  className="w-100" key={`${panier.idCaddies}-${marquage.id}`} ><RenderArticleConcerne surface={params.surface} emplacement={params.emplacement} panier={panier}
                                        marquage={params.marquage}
                                         numCommande={this.props.order.numCommande} color={params.color}
                                         orderId={this.props.order.idCommande} pictogramme={params.pictogramme}
                                         nbPanachages={this.props.nbPanachages} identifier={String(iNew)}
                                         surfacesEmplacements={[this.state.surfaces, this.state.emplacements]}
                                         onOrderUpdated={this.props.onOrderUpdated} paniers={params.paniers}
                                         activatePanachage={this.props.activatePanachage}
                                         activatePanachageQuadriluxe={this.props.activatePanachageQuadriluxe}
                                         activatePanachageTopQuadri={this.props.activatePanachageTopQuadri}
                                         activatePanachageSericoat={this.props.activatePanachageSericoat}
                                         activatePanachageSublimation={this.props.activatePanachageSublimation}
                                         activatePanachageBroderie={this.props.activatePanachageBroderie}
                                         selectPanachage={this.props.selectPanachage}
                                         confirmationFichiers={this.props.order.confirmationFichier}/></div>,
                );
                paniersConcernes.push(panier);
              } else if(panier.isModel3d) {
                paniersModel3d.push(panier);
              } else {
                paniersPanaches.push(panier);
              }
            }
          }
        }
      }
      return [articlesConcernes, nbArticlesConcernes, surfaceToPrint, emplacementToPrint, color, iNew,
        paniersConcernes, paniersPanaches];
    };

    const renderContentMarquage = (paniersConcernes: any[], marquage: any) => {
      const html: any = [];
      const paniersAndPictos = this.definePaniersAndPictos(paniersConcernes);
      const paniers: any[] = paniersAndPictos[0];
      const pictoInCart: any[] = paniersAndPictos[1];
      const printColors: any[] = this._listOfMarking();

      // On récupère la liste des creation_id Pour pouvoir séparer les articles
      const listCreationId: string[] = paniersConcernes.reduce((acc: string[], current: Cart) => {
        const key = current.creation_id === null ? 'null' : current.creation_id;
        if (!acc.includes(key)) {
          acc.push(current.creation_id);
        }
        return acc.slice();
      }, []);

      let i = 0;
      const tabKey: string[] = [];
      if(this.state.colors && this.state.emplacements && this.state.surfaces && this.state.idCaddies ) {
      for (const pictoId in pictoInCart) {
        const pictogramme = pictoInCart[pictoId];
        for (const couleur of this.state.colors) {
          for (const emplacement of this.state.emplacements) {
            for (const printColor of printColors) {
              for (const surface of this.state.surfaces) {
                for (const currentCreationId of listCreationId) {
                  for (const lignePanier of this.state.idCaddies) {
                    if (surface.nom === 'manche droite') {
                      surface.nom = 'manche';
                    }

                    const params: any = {
                      paniers: paniers,
                      pictogramme: pictogramme,
                      surface: surface,
                      emplacement: emplacement,
                      color: couleur,
                      marquage: marquage,
                      printColor: printColor,
                      idCaddies: lignePanier,
                      creationId: currentCreationId,
                    };
                    const result = renderArticleConcerne(params, i);
                    const ligneCaddies = getShopInfosInStorage().Ref === 'DT' ? lignePanier : paniers[0].idCaddies;

                    if (result[1] > 0 && surface && surface.id) {
                      i = result[5];
                      const params: any = {
                        pictogramme: pictogramme,
                        surface: result[2],
                        emplacement: result[3],
                        color: result[4],
                        idCaddies: ligneCaddies,
                        identifier: String(i),
                        marquage: marquage,
                        printColor: printColor
                      };

                      const key = pictogramme.id + '-' + couleur.Couleur + '-' + emplacement.id + '-' + surface.id +
                        '-' + marquage.id + '-' + couleur.cmjn.cyan + '-' + couleur.cmjn.magenta + '-' + couleur.cmjn.jaune
                        + '-' + couleur.cmjn.noir + '-' + printColor + '-' + lignePanier+ '-' + currentCreationId;
                      if (tabKey.indexOf(key) === -1) {
                        tabKey.push(key);
                        html.push(
                          <div key={key}>
                            {renderLigneGlobale(params, result[1], result[6])}
                            {renderArticlesConcernes(result[0], ligneCaddies + '-' + i)}
                          </div>,
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return (
        <div className="mb2" key={marquage.libelle}>
          <div>{html}</div>
          {renderContentModel3d(paniers, marquage)}
          {renderContentPanachage(paniers, marquage)}
        </div>
      );
    } else {
        return null;
      }
    };

    const renderPanachage = (panachage: any[]) => {
      return <div>{panachage}</div>;
    };

    const definePaniersToPanache = (paniers: Cart[], creationId: string) => {
      const result = [];
      for (const panier of paniers) {
        if (panier.panachage == '1' && panier.creation_id === creationId) {
          result.push(panier);
        }
      }
      return result;
    }

    const definePaniersToModel3d = (paniers: Cart[], creationId: string) => {
      const result = [];
      for (const panier of paniers) {
        if (panier.isModel3d && panier.panachage == '0' && panier.creation_id === creationId) {
          result.push(panier);
        }
      }
      return result;
    }

    const renderContentPanachage = (paniers: any[], marquage: any) => {
      const result = [];
      let tmp = [];
      let surfaceToPrint: any;
      let emplacementToPrint: any;
      let pictogrammeToPrint: any;
      let colorToPrint: any;
      let i: number = 1000;

      for (const nbPanachage of this.props.nbPanachages) {
        if (marquage.nom === nbPanachage.marquage) {
          if (nbPanachage.datas) {
            for (const data of nbPanachage.datas) {
              let nbArticles: number = 0;
              let key = nbPanachage.marquage + '-' + data.numeroBloc + '-' + data.picto + '-' + data.creation_id + '-' +
                data.color.Couleur;

              result.push(
                <p className="font14 mt3 mb0" style={{color: '#000'}} key={key}>
                  Panachage {marquage.libelle} <span className="bold">n°{data.numeroBloc}</span>
                </p>,
              );

              const articlesConcernes = [];
              const inTabarticlesConcernes: any = [];

              for (const panier of paniers) {
                if (panier.creation_id === data.creation_id) {
                  tmp = [];
                  nbArticles += Number(panier.Quantite);
                  panier.marquages = panier.marquages.sort((a: any, b: any) => {return a.surface_emplacement_id - b.surface_emplacement_id});
                  for (const marquagePanier of panier.marquages) {
                    emplacementToPrint = this.defineEmplacementToPrint(marquagePanier.emplacement);
                    pictogrammeToPrint = this.definePictogrammeToPrint(panier.article.produit.picto.nom);
                    colorToPrint = this.defineColorToPrint(panier.article.couleur);
                    if(this.state.surfaces) {
                      for (const surface of this.state.surfaces) {
                        if (surface.nom === marquagePanier.surface) {
                          const identifier = panier.idCaddies + '-' + i;
                          i++;
                          surfaceToPrint = surface;

                          if (inTabarticlesConcernes.indexOf(panier.idCaddies) === -1) {
                            inTabarticlesConcernes.push(panier.idCaddies);
                            if (emplacementToPrint && emplacementToPrint.nom) {
                              key += panier.idCaddies + '-' + surface.nom + '-' + emplacementToPrint.nom;
                              articlesConcernes.push(
                                <RenderArticleConcerne key={key}
                                                       surface={surfaceToPrint} emplacement={emplacementToPrint}
                                                       panier={panier} marquage={marquage} identifier={identifier}
                                                       pictogramme={pictogrammeToPrint} color={colorToPrint}
                                                       numCommande={this.props.order.numCommande}
                                                       orderId={this.props.order.idCommande} paniers={paniers}
                                                       surfacesEmplacements={[this.state.surfaces, this.state.emplacements]}
                                                       onOrderUpdated={this.props.onOrderUpdated}
                                                       nbPanachages={this.props.nbPanachages}
                                                       activatePanachage={this.props.activatePanachage}
                                                       activatePanachageBroderie={this.props.activatePanachageBroderie}
                                                       activatePanachageQuadriluxe={this.props.activatePanachageQuadriluxe}
                                                       activatePanachageTopQuadri={this.props.activatePanachageTopQuadri}
                                                       activatePanachageSericoat={this.props.activatePanachageSericoat}
                                                       activatePanachageSublimation={this.props.activatePanachageSublimation}
                                                       selectPanachage={this.props.selectPanachage}
                                                       confirmationFichiers={this.props.order.confirmationFichier}/>,
                              );
                            }
                          }
                        }
                      }
                    }

                    if (surfaceToPrint) {
                      const params: Params = {
                        pictogramme: pictogrammeToPrint,
                        surface: surfaceToPrint,
                        emplacement: emplacementToPrint,
                        color: colorToPrint,
                        idCaddies: paniers[0].idCaddies,
                        identifier: String(i),
                        paniers: paniers,
                        marquage: marquage,
                      };
                      const temp = [];
                      temp.push(renderLigneGlobale(params, nbArticles,
                        definePaniersToPanache(paniers, data.creation_id)));
                      temp.push(renderArticlesConcernes(articlesConcernes, paniers[0].idCaddies + '-' + String(i)));
                      tmp.push(<div key={key + '-' + i}>{temp}</div>);
                    }
                  }
                }
              }
              result.push(
                <div style={{border: '1px solid #000', borderLeftWidth: '5px'}}
                     key={marquage.libelle + '-' + data.numeroBloc}>
                  {tmp}
                </div>,
              );
            }
          }
        }
      }
      return renderPanachage(result);
    };

    const renderContentModel3d = (paniers: Cart[], marquage: Marquage) => {
      const result: Map<string, any> = new Map<string, any>();
      let tmp = [];
      let surfaceToPrint: Surface | undefined;
      let emplacementToPrint: Emplacement | undefined;
      let pictogrammeToPrint: Picto | undefined;
      let colorToPrint: Color | undefined;
      let i: number = 2000;
      const nbArticles: Map<string, number> = new Map<string, number>();
      let key = "model3d_";
      let model3DInCMD = false;

      const articlesConcernes: Map<string, any> = new Map<string, any>();
      const inTabarticlesConcernes: string[] = [];
      let lignesConcernees: Cart[] = [];
      const listCreationId: string[] = [];

      for (const panier of paniers) {
        if(articlesConcernes.get(panier.creation_id) === undefined) {
          nbArticles.set(panier.creation_id, 0);
          articlesConcernes.set(panier.creation_id, []);
        }
        if (panier.creation_id && panier.panachage == '0' && panier.isModel3d) {
          model3DInCMD = true;
          tmp = [];
          nbArticles.set(panier.creation_id,paniers.filter(elt => elt.creation_id === panier.creation_id).reduce((sum, current) => sum + Number(current.Quantite), 0));
          panier.marquages = panier.marquages.sort((a: Marquage, b: Marquage) => {return a.surface_emplacement_id - b.surface_emplacement_id});
            for (const marquagePanier of panier.marquages) {
              emplacementToPrint = this.defineEmplacementToPrint(marquagePanier.emplacement);
              pictogrammeToPrint = this.definePictogrammeToPrint(panier.article.produit.picto.nom);
              colorToPrint = this.defineColorToPrint(panier.article.couleur);
              if(this.state.surfaces) {
                for (const surface of this.state.surfaces) {
                  if (surface.nom === marquagePanier.surface) {
                    const identifier = panier.idCaddies + '-' + i;
                    i++;
                    surfaceToPrint = surface;
                    if (inTabarticlesConcernes.indexOf(panier.idCaddies) === -1) {
                      inTabarticlesConcernes.push(panier.idCaddies);
                      if (emplacementToPrint && emplacementToPrint.nom) {
                        key += panier.idCaddies + '-' + surface.nom + '-' + emplacementToPrint.nom;
                        if(articlesConcernes.get(panier.creation_id)) {
                          articlesConcernes.set(panier.creation_id,[
                            <RenderArticleConcerne key={key}
                                surface={surfaceToPrint} emplacement={emplacementToPrint}
                                panier={panier} marquage={marquage} identifier={identifier}
                                pictogramme={pictogrammeToPrint} color={colorToPrint}
                                numCommande={this.props.order.numCommande}
                                orderId={this.props.order.idCommande} paniers={paniers}
                                surfacesEmplacements={[this.state.surfaces, this.state.emplacements]}
                                onOrderUpdated={this.props.onOrderUpdated}
                                nbPanachages={this.props.nbPanachages}
                                activatePanachage={this.props.activatePanachage}
                                activatePanachageBroderie={this.props.activatePanachageBroderie}
                                activatePanachageQuadriluxe={this.props.activatePanachageQuadriluxe}
                                activatePanachageTopQuadri={this.props.activatePanachageTopQuadri}
                                activatePanachageSericoat={this.props.activatePanachageSericoat}
                                activatePanachageSublimation={this.props.activatePanachageSublimation}
                                selectPanachage={this.props.selectPanachage}
                                confirmationFichiers={this.props.order.confirmationFichier}/>, ...articlesConcernes.get(panier.creation_id)])
                        }
                      }
                    }      
                  }
                }
              }

              if (surfaceToPrint && pictogrammeToPrint && emplacementToPrint && colorToPrint) {
                const params: Params = {
                  pictogramme: pictogrammeToPrint,
                  surface: surfaceToPrint,
                  emplacement: emplacementToPrint,
                  color: colorToPrint,
                  idCaddies: paniers[0].idCaddies,
                  identifier: String(i),
                  paniers: paniers,
                  marquage: marquage,
                };
                const temp = [];
                lignesConcernees = definePaniersToModel3d(paniers, panier.creation_id);
                const ligneGlobale = renderLigneGlobale(params, nbArticles.get(panier.creation_id) || 0, lignesConcernees);
                if(ligneGlobale) {
                  temp.push(ligneGlobale);
                  temp.push(renderArticlesConcernes(articlesConcernes.get(panier.creation_id), paniers[0].idCaddies + '-' + String(i)));
                  tmp.push(<div key={key + '-' + i}>
                    {temp}
                  </div>);
                }
              }
            }
            if(model3DInCMD) {
                const withBeforeUploadStatusId = (this.state as Record<string, number>)[panier.creation_id as string] ?? panier.withBeforeUploadStatusId;
                const loaderId = (this.state as Record<string, boolean>)?.[panier.creation_id +"-glbLoading"] ?? false;
                const dataFormGlb = (this.state as Record<string, FormGenerateTexture>)[panier.creation_id +"-dataFormGlb"];
                {withBeforeUploadStatusId ? result.set(panier.creation_id + '_bloc',
                  <div className='title3dbloc' key={panier.creation_id + '_bloc'}>
                    {this.props.isInternalUser && !this.props.customerView && (
                      <>
                        <span className='badge badge-warning'>new</span> <span className='black bold'>Vue 3D</span>
                        <Model3dView
                          panier={panier as Model3dViewData}
                          idCommande={parseInt(this.props.order.idCommande,10)}
                          numCommande={this.props.order.numCommande}
                          linkVersion
                          enabledPostProcessing={this.props.enabledPostProcessing}
                        />
                      </>
                    )}
                  </div>,
                ) : result.set(panier.creation_id + '_bloc',<div key={panier.creation_id + '_bloc'} className='title3dbloc'></div>)}
                result.set(panier.creation_id,
                  <div
                    key={panier.creation_id + '-3d'} className='d-flex flex-mobile border3dbloc'>
                      {dataFormGlb && <RequestQueue idCommande={parseInt(this.props.order.idCommande,10)} data={dataFormGlb} updateTextureGlb={this.updateTextureGlb}/>}
                      <Model3dView
                        loading={loaderId}
                        glbVersion={this.state.glbVersion}
                        panier={panier as Model3dViewData}
                        idCommande={parseInt(this.props.order.idCommande,10)}
                        numCommande={this.props.order.numCommande}
                        enabledPostProcessing={this.props.enabledPostProcessing}
                      />
                      <div className='d-flex flex-grow-1 flex-column'>
                        {tmp}
                      </div>
                  </div>
                );
                listCreationId.push(panier.creation_id);
              }
          }
        }
        const finalResult: Element[] = [];
        const alreadySet: string[] = [];
        for (const key in listCreationId) {
          if (Object.prototype.hasOwnProperty.call(listCreationId, key)) {
            const element = listCreationId[key];
            if(!alreadySet.includes(element)) {
              finalResult.push(result.get(element+'_bloc'));
              finalResult.push(result.get(element));
              alreadySet.push(element);
            }
          }
        }
        return <div>{finalResult}</div>;
    };

    const renderMarquageName = (marquage: any) => {
      return (
        <p key={marquage.id} className="pa05 black big mb0 border-bottom" style={{background: '#fff'}}>
          Marquage <span className="bold">{marquage.libelle}</span>
          {(this.props.order.MarquageClair && this.state.authorizedFiles) && (
            <span className="grey ml1 small">({this.state.authorizedFiles.join((', '))})</span>
          )}
        </p>
      );
    };

    const renderContentFiles = () => {
      const html = [];
      if (this.props.marquages && this.state.pictogrammes && this.state.emplacements
        && this.state.surfaces && this.state.colors) {
        for (const marquage of this.props.marquages) {
          const paniersConcernes = [];
          for (const panier of this.props.order.panier) {
            if (panier.marquage === marquage.nom && parseInt(panier.Quantite,10) > 0) {
              paniersConcernes.push(panier);
            }
          }

          if (marquage.libelle !== null && paniersConcernes.length > 0 && paniersConcernes[0]['marquage'] &&
            paniersConcernes[0]['marquage'].indexOf(marquage.nom) != -1) {
            html.push(renderMarquageName(marquage));
            html.push(renderContentMarquage(paniersConcernes, marquage));
          }
        }
      }

      return <div>{html}</div>;
    };

    return renderContentFiles();
  }
}
